import { HeaderWrapper } from './Header.styled';
import headerLogo from './../../resources/logo.png';
import { Col, Row,  Nav, NavItem, Collapse, Navbar, NavbarToggler, NavLink } from 'reactstrap';
import { useState } from 'react';
import MultiLevelDropdown from '../utils/MultiLevelDropdown/MultiLevelDropdown';
import bellIcon from './../../resources/golden-bell-icon.png';
import MultiLevelDropdown2 from '../utils/MultiLevelDropdown2/MultiLevelDropdown2';

function Header() {

	const [isNavOpen, setIsNavOpen] = useState(false);
	const navToggle = () => setIsNavOpen(!isNavOpen);
	return(
	<HeaderWrapper>
		<div style={{color: 'rgb(191, 219, 32)', backgroundColor: 'rgb(0, 0, 0)', display: 'block'}}>
			<div style={{backgroundColor: 'rgb(0, 0, 0)'}}>
				<span></span>
			</div>
			<div className="headline">Subscribe to Miss TecHack for more tutorials</div>
			<div className="message" style={{display: 'none'}}></div>
			<div className="button" style={{backgroundColor: 'rgb(0, 0, 0)',borderColor: 'rgb(0, 0, 0)',color: 'rgb(191, 219, 32)'}}>
				<a href="https://www.youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA">
					Click Here! 
					<img src={bellIcon} alt="" width="30" height="30" style={{display:'inline',verticalAlign:'sub'}} />
				</a>
			</div>
		</div>

		<header className="site-header">
			<div className="header-bar site-header-focus-item" data-section="section-above-header-builder">
				<div data-section="section-above-header-builder">
					<Row>
						<Col  sm="1" md="2">
							<span className="site-logo-img">
								<a href="https://letsunderstandjava.com/" className="custom-logo-link" rel="home" aria-current="page">
									<img width="50" height="83" src={headerLogo} className="header-logo" alt="Grow As You Learn" decoding="async" data-lazy-sizes="(max-width: 50px) 100vw, 50px" />
								</a>
							</span>
						</Col>
						<Col   sm="1" md="2"></Col>
						<Col  sm="2" md="4">
							<span className="site-title" itemProp="name">
								<a href="https://letsunderstandjava.com/" rel="home" itemProp="url">
									Grow As You Learn
								</a>
							</span>
							<p className="site-description" itemProp="description">
								Never stop learning!
							</p>
						</Col>
					</Row>
				</div>
			</div>

			<div className="header-nav">
				<Navbar style={{flexWrap: 'nowrap'}} expand="xl" light>
					<NavbarToggler onClick={navToggle} />
					<Collapse isOpen={isNavOpen} navbar style={{flexBasis: 'auto'}}>
					<Nav className="ml-auto d-flex justify-content-between align-items-center  px-4" navbar style={{flexDirection: 'row', width: '100%'}}>
						<NavItem>
							<NavLink href="/">Home</NavLink>
						</NavItem>
						<NavItem>
							<NavLink href="/why-learn-java">Why Learn Java?</NavLink>
						</NavItem>
						<MultiLevelDropdown/>
						<MultiLevelDropdown2/>
						<NavItem>
							<NavLink href="/video-tutorials">Video Tutorials</NavLink>
						</NavItem>
						<NavItem>
							<NavLink href="/about">About</NavLink>
						</NavItem>
						<NavItem>
							<NavLink href="/contact">Contact</NavLink>
						</NavItem>
					</Nav>
					</Collapse>
				</Navbar>
			</div>
		</header>
	</HeaderWrapper>
	)
};

export default Header;
